import React, { useContext, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { gray100 } from '../../constants/colors';
import MypageCompleteCard from '../uiParts/MypageCompleteCard';
import CustomSnackbar from '../uiParts/CustomSnackbar';
import SideBar from '../uiParts/SideBar';
import { sideBarWidth, spHeaderHeight } from '../../constants/location';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/auth';
import MetaTitle from '../utils/MetaTitle';

const styles = {
  page: {
    height: '100vh',
    display: 'flex',
    '@media (max-width: 960px)': {
      flexDirection: 'column',
      paddingTop: '0',
      justifyContent: 'flex-start',
    },
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingTop: '18vh',
    backgroundColor: '#FBFBFB',
    width: '-webkit-fill-available',
    marginLeft: sideBarWidth,
    '@media (max-width: 960px)': {
      marginTop: spHeaderHeight,
      marginLeft: 0,
      height: '100%',
      alignItems: 'flex-start',
    },
    '@media (max-width: 600px)': {
      paddingTop: '50%',
    },
  },
  sidebar: {
    backgroundColor: gray100,
    height: '100vh',
    position: 'fixed',
    width: sideBarWidth,
    '@media screen and (max-width:960px)': {
      height: spHeaderHeight,
      width: '100%',
      zIndex: '100',
    },
  },
};

const StaffInviteCancel: React.FC = () => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const { user, isLoading } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    const handlePopState = (): void => {
      setSnackbarOpen(true);

      // ブラウザバックを無効化
      window.history.pushState(null, '', window.location.href);
    };

    // 初回ロード時にブラウザバックを無効化
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  useEffect(() => {
    if (isLoading) return;
    // 未ログイン状態の場合はログイン画面へ遷移
    if (user === null) navigate('/');
  }, [user, isLoading]);

  return (
    <>
      <MetaTitle />
      <Box sx={styles.page}>
        <Box sx={styles.sidebar}>
          <SideBar />
        </Box>
        <Box sx={styles.container}>
          <MypageCompleteCard
            IconComponent={CheckCircleIcon}
            titleText={'招待を取消しました'}
            messageText={'同じユーザーが再び利用する場合は、新しく招待してください。'}
            buttonText="担当者一覧へ"
            targetPath="/staff"
          />
        </Box>
      </Box>

      <CustomSnackbar
        autoHideDuration={6000}
        open={snackbarOpen}
        onClose={(): void => setSnackbarOpen(false)}
        text={'前のページに戻れません。'}
      />
    </>
  );
};

export default StaffInviteCancel;
